import React from 'react';
export default React.createContext('en_US');
//# sourceMappingURL=intl-context.js.map